export const PERMISSIONS = {
  GENERAL_SETTINGS: 1,
  WORKERS: 2,
  FARMING_BLOCK: 3,
  ACTIVITIES: 4,
  DEVICES: 5,
  WORKDAY: 6,
  DATA_EDIT: 7,
  STICKERS: 8,
  USERS: 9,
  LAST_WORKING_DAY_SUMMARY: 10,
  DAILY_PICK_SUMMARY: 11,
  DAILY_AGRO_SUMMARY: 12,
  DAILY_PACKING_SUMMARY: 13,
  WEEKLY_PICK_SUMMARY: 14,
  WEEKLY_AGRO_SUMMARY: 15,
  CROPS: 16
};
